import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Home_1 from '../../../assets/images/home_page_2/slider/01.png'
import Home_2 from '../../../assets/images/home_page_2/slider/02.png'

const Slide = {
  dots: true,
  arrows: true,
  Infinity: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 3000,

}


const Hometwosilder = () => {
  return (
    <>
      <section id="home-two-slider" className="home-two-slider-main-block">
        <div className="container">
          <div className="slider-container">
            <Slider className="slider home-autoplay-slider" {...Slide}>
              <div className="home-two-slider-block">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="home-two-slider-dtl">
                      <h1 className="home-two-slider-title cormorant-font">
                        Large Ceramic Coffe Cup
                      </h1>
                      <p>
                        Use Code Eid40 at Checkout for 40% weaver <br /> your Three
                        Orders, end, 18-01-2025
                      </p>
                      <Link to="#" title="" className="btn btn-primary-second">
                        Shop Now <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="home-two-slider-img">
                      <img
                        src={Home_1}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-two-slider-block">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="home-two-slider-dtl">
                      <h1 className="home-two-slider-title cormorant-font">
                        Large Ceramic Coffe Cup
                      </h1>
                      <p>
                        Use Code Eid40 at Checkout for 40% weaver <br /> your Three
                        Orders, end, 18-01-2025
                      </p>
                      <Link to="#" title="" className="btn btn-primary-second">
                        Shop Now <i className="flaticon-right-arrow" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="home-two-slider-img">
                      <img
                        src={Home_2}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
            <div className="custom-navigation">
              <span className="nav-number">01</span>
              <div className="nav-line-container">
                <div className="nav-line" />
              </div>
              <span className="current-slide">01</span>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default Hometwosilder
